$(document).ready(function () {
    $(document).on("click", ".mobile-collapsible .trigger:not(.disabled)", function () {
        var $mobileCollabasible = $(this).parents(".collapsible");
        $(this).parents(".mobile-collapsible").toggleClass("shown");
        $.event.trigger("mobileCollapsibleClicked", [$mobileCollabasible]);
    });

    $(document).on("click", ".collapsible .trigger:not(.disabled)", function () {
        var $collabasible = $(this).parents(".collapsible");
        $collabasible.toggleClass("shown");
        $.event.trigger("collapsibleClicked", [$collabasible]);
    });
    $(document).on("click", ".exclusive-collapsible .trigger:not(.disabled)", function () {
        var $this = $(this).parents(".exclusive-collapsible");
        if ($this.hasClass("shown")) {
            $(".exclusive-collapsible").removeClass("shown");
        } else {
            $(".exclusive-collapsible").removeClass("shown");
            $this.addClass("shown");
        }
    });
})